import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { appTranslate } from '../../i18n';
import copies from '../../copies.json';

type ExampleKey = keyof Omit<typeof copies.dm_brief_creation.rephrase_step.examples, 'title'>;
const examples: ExampleKey[] = ['1', '2', '3'];

export const RephraseExamples = () => (
  <Stack direction="column" gap="2">
    <Text fontWeight="semibold" size="b_sm">
      {appTranslate('rephrase_step.examples.title')}
    </Text>
    <Stack direction="column" gap="2">
      {examples.map((example) => (
        <Stack key={example} paddingX="4" paddingY="2" backgroundColor="grey_100" borderRadius="lg">
          <Text size="b_sm">&quot;{appTranslate(`rephrase_step.examples.${example}`)}&quot;.</Text>
        </Stack>
      ))}
    </Stack>
  </Stack>
);
